import React from 'react';

import { VerificationRequestType } from 'src/api';
import { Modal } from 'src/components/common';
import { ApproveVerificationRequestByVerifierModalContent } from 'src/components/verificationRequest';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import type { ApproveVerificationRequestByVerifierModalArgs } from './types';

export const ApproveVerificationRequestByVerifierModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<ApproveVerificationRequestByVerifierModalArgs>(
      ModalId.ApproveVerificationRequestByVerifier,
    );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  if (
    isOpen &&
    (!args?.inboxItemId || !args?.verificationRequestType || !args?.permissiblePurposeId)
  ) {
    throw new Error(`Missing some modal args: ${JSON.stringify(args)}`);
  }

  return (
    <Modal
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
      maxWidth={550}
    >
      <ApproveVerificationRequestByVerifierModalContent
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
        inboxItemId={args?.inboxItemId || ''}
        verificationRequestType={
          args?.verificationRequestType || VerificationRequestType.GovernmentalVerification
        }
        permissiblePurposeId={args?.permissiblePurposeId || ''}
        paymentMethodId={args?.paymentMethodId || ''}
      />
    </Modal>
  );
};
